import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icons } from '../common';
import './AdminLogin.css';
import { API_BASE } from '../../constants/urls';



const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setMessage('');

        try {
            const response = await fetch(`${API_BASE}/api/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const result = await response.json();

            if (response.ok) {
                setMessage(result.message || 'If this email exists, a reset code has been sent.');
                // After a short delay, show the reset password screen
                setTimeout(() => {
                    navigate('/reset-password', { state: { email } });
                }, 3000);
            } else {
                setError(result.error || 'Failed to request password reset');
            }
        } catch (err) {
            setError('Network error. Please try again.');
            console.error('Forgot password error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <div className="admin-login-icon">
                        <Icons.LockIcon className="w-8 h-8 text-blue-600" />
                    </div>
                    <h1 className="admin-login-title">Forgot Password</h1>
                    <p className="admin-login-subtitle">
                        Enter your email to receive a reset code
                    </p>
                </div>

                {message ? (
                    <div className="animate-fadeIn">
                        <div className="success-message">
                            <Icons.CheckCircleIcon className="success-icon" />
                            {message}
                        </div>
                        <p className="text-center text-sm text-gray-600 mt-4">
                            Redirecting to password reset page...
                        </p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="admin-login-form">
                        <div className="form-group">
                            <label htmlFor="email" className="form-label">
                                Email Address
                            </label>
                            <div className="input-wrapper">
                                <Icons.UserIcon className="input-icon" />
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="form-input"
                                    placeholder="Enter your registered email"
                                    required
                                    disabled={isLoading}
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="error-message">
                                <Icons.ExclamationIcon className="error-icon" />
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isLoading || !email}
                            className="login-button"
                        >
                            {isLoading ? (
                                <>
                                    <div className="loading-spinner"></div>
                                    Sending...
                                </>
                            ) : (
                                'Send Reset Code'
                            )}
                        </button>

                        <div className="forgot-password-link-container">
                            <button
                                type="button"
                                onClick={() => navigate('/admin/login')}
                                className="forgot-password-link"
                            >
                                Back to Login
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
